export const faqData = [
  {
    id: 1,
    question: " Can MinEMI help me find lenders with a low credit score?",
    answer:
      "Yes, MinEMI connects you with lenders who cater to all credit profiles and help you find the best possible terms.",
  },
  {
    id: 2,
    question: " How much can I save with MinEMI’s Balance Transfer?",
    answer:
      "Savings depend on your current interest rate, remaining tenure, and the new lender’s offer. Use MinEMI’s calculator for an instant estimate.",
  },
  {
    id: 3,
    question: " Can I transfer my car loan mid-tenure?",
    answer:
      "Absolutely. Transferring mid-tenure often results in the maximum savings by reducing interest costs.",
  },
  {
    id: 4,
    question: "Are there any hidden charges?",
    answer:
      "MinEMI ensures transparency by listing all processing fees, prepayment penalties, and other charges upfront.",
  },
  {
    id: 5,
    question: "When should I not transfer my car loan?",
    answer:
      "Avoid transferring if you are nearing the end of your loan tenure or if processing fees outweigh the savings.",
  },
];
